import { accountRequestStatusEnum } from '@/constants/user'

export function isCompletedAccountByApex(account) {
  return [
    accountRequestStatusEnum.COMPLETE,
    accountRequestStatusEnum.VENDOR_REQUEST_SUBMITTED,
  ].includes(account.accountRequestStatus)
}
